const PROJECT_TYPE = Object.freeze({
  ECO: 3,
  EMERGENCY: 4
});

export { PROJECT_TYPE };
